/* eslint-disable no-console */
/* eslint-disable complexity */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link, useHistory } from 'react-router-dom';

import whiteLogo from '../../../assets/images/logo-white.svg';
import pcsgradesIcon from '../../../assets/images/pcsgrades-logo.svg';
import termsOfServiceIcon from '../../../assets/images/menu-icons/terms-of-service.svg';
import privacyPolicyIcon from '../../../assets/images/menu-icons/privacy-policy.svg';
import supportIcon from '../../../assets/images/menu-icons/support.svg';
import logOutIcon from '../../../assets/images/menu-icons/log-out-new.svg';
import resourcesIcon from '../../../assets/images/menu-icons/resources.svg';
import medalSolid from '../../../assets/images/menu-icons/medal-solid.svg';
import usersIcon from '../../../assets/images/menu-icons/users.svg';
import statsIcon from '../../../assets/images/statistics-icon.svg';
import listIcon from '../../../assets/images/list-icon.svg';
import shareWithFriendsIcon from '../../../assets/images/menu-icons/share-with-friends.svg';
import { getLeadPartnerDashboard } from '../../../utils/getLeadPartnerDashboard';
import { values as DASH_ORDER } from '../../../utils/options/leadPartnerDashboards';

const LeadPartnerSidebar = ({ location, logout, user }) => {
  const notProduction = process.env.NODE_ENV !== 'production';
  const twoFactorEnabled = notProduction || user.twoFactorAuthEnabled;
  const dashboardsToShow = getLeadPartnerDashboard(user);

  const isPathActive = (path) => location.pathname.startsWith(path);
  const history = useHistory();

  const logoutEditor = () => {
    logout();
    history.push('/login');
  };

  const sideBarDashboards = {
    Referrals: (
      <li
        className={isPathActive('/referrals') ? 'nav-item active' : 'nav-item'}
      >
        <Link className="nav-link" to="/referrals">
          <img className="menu-icon" src={pcsgradesIcon} alt="Referrals" />
          <span className="menu-title">
            {user.leadPartnerWithMetrics ? 'Advisor Referrals' : 'Referrals'}
          </span>
        </Link>
      </li>
    ),
    'Outreach/Users': (
      <li className={isPathActive('/users') ? 'nav-item active' : 'nav-item'}>
        <Link className="nav-link" to="/users">
          <img className="menu-icon" src={usersIcon} alt="Metrics" />
          <span className="menu-title">Outreach/Users</span>
        </Link>
      </li>
    ),
    'Program Metrics': (
      <li className={isPathActive('/metrics') ? 'nav-item active' : 'nav-item'}>
        <Link className="nav-link" to="/metrics">
          <img className="menu-icon" src={statsIcon} alt="Metrics" />
          <span className="menu-title">Program Metrics</span>
        </Link>
      </li>
    ),
    'Advisor Metrics': (
      <li
        className={
          isPathActive('/closed-cases') ? 'nav-item active' : 'nav-item'
        }
      >
        <Link className="nav-link" to="/closed-cases">
          <img className="menu-icon" src={listIcon} alt="Metrics" />
          <span className="menu-title">Advisor Metrics</span>
        </Link>
      </li>
    ),
    Benefits: (
      <li
        className={isPathActive('/benefits') ? 'nav-item active' : 'nav-item'}
      >
        <Link className="nav-link" to="/benefits">
          <img className="menu-icon" src={medalSolid} alt="Benefits" />
          <span className="menu-title">Benefits</span>
        </Link>
      </li>
    ),
    Organization: (
      <li
        className={isPathActive('/resource') ? 'nav-item active' : 'nav-item'}
      >
        <Link className="nav-link" to="/resource">
          <img className="menu-icon" src={resourcesIcon} alt="Organization" />
          <span className="menu-title">Organization</span>
        </Link>
      </li>
    ),
    'Invite Users': (
      <>
        <div className="divider-item"></div>
        <li
          className={
            isPathActive('/invite-users') ? 'nav-item active' : 'nav-item'
          }
        >
          <Link className="nav-link" to="/invite-users">
            <img
              className="menu-icon"
              src={shareWithFriendsIcon}
              alt="Invite Users"
            />
            <span className="menu-title">Invite Users</span>
          </Link>
        </li>
      </>
    ),
  };

  return (
    <nav
      className="sidebar sidebar-offcanvas lead-partner-sidebar"
      id="sidebar"
    >
      <div className="text-center sidebar-brand-wrapper d-flex align-items-center">
        <a className="sidebar-brand brand-logo" href="/">
          <img src={whiteLogo} alt="logo" />
        </a>
      </div>
      <ul className="nav">
        {twoFactorEnabled && (
          <>
            <li
              className={
                isPathActive('/profile') ? 'nav-item active' : 'nav-item'
              }
            >
              <Link className="nav-link" to="/profile">
                <img className="menu-icon" src={medalSolid} alt="Profile" />
                <span className="menu-title">Profile</span>
              </Link>
            </li>
            {dashboardsToShow &&
              DASH_ORDER.filter((dashboard) =>
                dashboardsToShow.includes(dashboard)
              ).map((dashboard) => (
                <React.Fragment key={dashboard}>
                  {sideBarDashboards[dashboard]}
                </React.Fragment>
              ))}
            <div className="divider-item"></div>
          </>
        )}

        <li
          className={
            isPathActive('/terms-of-use') ? 'nav-item active' : 'nav-item'
          }
        >
          <Link className="nav-link" to="/terms-of-use">
            <img
              className="menu-icon"
              src={termsOfServiceIcon}
              alt="Terms of Use"
            />
            <span className="menu-title">Terms of Use</span>
          </Link>
        </li>
        <li
          className={
            isPathActive('/privacy-policy') ? 'nav-item active' : 'nav-item'
          }
        >
          <Link className="nav-link" to="/privacy-policy">
            <img
              className="menu-icon"
              src={privacyPolicyIcon}
              alt="Privacy Policy"
            />
            <span className="menu-title">Privacy Policy</span>
          </Link>
        </li>
        <li
          className={isPathActive('/support') ? 'nav-item active' : 'nav-item'}
        >
          <Link className="nav-link" to="/support">
            <img className="menu-icon" src={supportIcon} alt="Support" />
            <span className="menu-title">Support</span>
          </Link>
        </li>
        <li className="nav-item" onClick={() => logoutEditor()}>
          <div className="nav-link">
            <img className="menu-icon" src={logOutIcon} alt="Log out" />
            <span className="menu-title">Log Out</span>
          </div>
        </li>
      </ul>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  user: state.session.user,
});

const mapDispatchToProps = (_dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LeadPartnerSidebar));
